// extracted by mini-css-extract-plugin
module.exports = {"btn":"NavigatorBlock-module__btn___3ikgz"};